// extracted by mini-css-extract-plugin
module.exports = {"successColor":"Notification_successColor__f358a","infoColor":"Notification_infoColor__a9265","errorColor":"Notification_errorColor__e62b5"};